import React, { useEffect } from "react";
import FaqSection from "../../components/UserSideComponents/AboutUs/FaqSection";
import Banner from "../../components/UserSideComponents/common/Banner";
import img from "../../Assets/banner.png";
import Story from "../../components/UserSideComponents/AboutUs/Story";
import Portfolio from "../../components/UserSideComponents/AboutUs/Portfolio";

const About = () => {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);
  return (
    <>
      <Banner heading={"About Us"} image={img} />
      <Story />
      <Portfolio />
      <FaqSection />
    </>
  );
};

export default About;
